import React, { Fragment } from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { ArrowRightIcon, GiftIcon, TrophyIcon, ZapIcon } from 'lucide-react';
import { episodeChapters, progressiveEngagementFramework } from '../data/abbviePro';
const frameworkIcons = [GiftIcon, ZapIcon, TrophyIcon];
export function SnackificationModelScreen() {
  const reduceMotion = useReducedMotion();
  return <section className="flex min-h-screen items-center bg-presentation-canvas px-6 py-20" aria-labelledby="model-title" data-id="element-337" data-mp="1utn4nngccuqk">
      <div className="mx-auto w-full max-w-7xl" data-id="element-338" data-mp="1zlx1lnfviv2c">
        <p className="mb-4 text-sm font-semibold text-primary" data-id="element-339" data-mp="1zmoom9venkh0">03 - The snackification model</p>
        <h2 id="model-title" className="max-w-3xl text-4xl font-bold leading-tight text-secondary md:text-6xl" data-id="element-340" data-mp="1ku4m9bg2xh0m">
          A Netflix-style episodic journey
        </h2>
        <p className="mt-5 max-w-2xl text-lg text-slate-500" data-id="element-341" data-mp="1bvszjkic33dg">
          Portal content breaks down into 5-7 discrete, episodic chapters - each moving from introduction to deeper topic selection.
        </p>

        <div className="mt-14 flex flex-col gap-2 overflow-x-auto pb-2 lg:flex-row lg:items-stretch" data-id="element-342" data-mp="r2urxdz4ro72">
          {episodeChapters.map((chapter, index) => <Fragment key={chapter.number} data-id="element-343" data-mp="11350ume4u9gf" data-mpi={index}>
              <motion.div initial={reduceMotion ? false : {
            opacity: 0,
            y: 14
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.22,
            delay: index * 0.04,
            ease: [0.23, 1, 0.32, 1]
          }} className="min-w-[180px] flex-1 rounded-2xl border border-slate-200 bg-white p-5" data-id="element-344" data-mp="111tz0s48zbry">
                <span className="text-xs font-bold text-abbvie-cyan" data-id="element-345" data-mp="i52ao49um6h1">{chapter.number}</span>
                <h3 className="mt-2 text-sm font-bold text-abbvie-navy" data-id="element-346" data-mp="dbg2opemqqrk">{chapter.title}</h3>
                <p className="mt-2 text-xs leading-relaxed text-slate-500" data-id="element-347" data-mp="3lr9mbd49cicu">{chapter.caption}</p>
              </motion.div>
              {index < episodeChapters.length - 1 && <ArrowRightIcon className="mx-auto hidden h-4 w-4 shrink-0 self-center text-slate-300 lg:block" aria-hidden="true" data-id="element-348" data-mp="1kpjvg09pzmff" />}
            </Fragment>)}
        </div>

        <div className="mt-16 grid gap-4 sm:grid-cols-3" data-id="element-349" data-mp="1ug67jki89utd">
          {progressiveEngagementFramework.map((item, index) => {
          const Icon = frameworkIcons[index];
          return <motion.div key={item.stage} initial={reduceMotion ? false : {
            opacity: 0,
            y: 14
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.22,
            delay: index * 0.05,
            ease: [0.23, 1, 0.32, 1]
          }} className="rounded-2xl bg-abbvie-navy p-6 text-white" data-id="element-350" data-mp="11sipac4fjg9w" data-mpi={index}>
                <Icon className="h-6 w-6 text-abbvie-cyan" aria-hidden="true" data-id="element-351" data-mp="2m6kcusc6dytf" />
                <h3 className="mt-4 text-lg font-bold" data-id="element-352" data-mp="2r65ni00pjvlz">{item.stage}</h3>
                <p className="mt-2 text-sm leading-relaxed text-white/60" data-id="element-353" data-mp="2r8i5gd6gu5z1">{item.description}</p>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}